import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { tenants } from "utils/tenants";

import permissions from "app/permissions";
import CreateUniversityForm from "./Create";
import EditUniversityForm from "./Edit";
import ShowUniversityForm from "./Show";
import ListUniversities from "./List";
import { AdministrationServicePath, UNIVERSITIES } from "utils/constants";

export const resources = {
  isMenu: true,
  icon: <AccountBalanceIcon />,
  tenancies: [tenants.MU],
  name: AdministrationServicePath + UNIVERSITIES,
  title: "Списък университети",
  list: <ListUniversities />,
  create: <CreateUniversityForm />,
  edit: <EditUniversityForm />,
  show: <ShowUniversityForm />,
  permissions: permissions.canPreviewExternalUniversities,
  createPermission: permissions.canManageExternalUniversities,
  editPermission: permissions.canManageExternalUniversities,
  showPermission: permissions.canPreviewExternalUniversities,
};
